import _regeneratorRuntime from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/regenerator";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/asyncToGenerator";
import _classCallCheck from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/classCallCheck";
import _createClass from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/createClass";
import _possibleConstructorReturn from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/possibleConstructorReturn";
import _getPrototypeOf from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/getPrototypeOf";
import _inherits from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/inherits";
import RequestBaseData from "./RequestBaseData";
import axios from "axios";

var ContactChangeRequest =
/*#__PURE__*/
function (_RequestBaseData) {
  _inherits(ContactChangeRequest, _RequestBaseData);

  function ContactChangeRequest() {
    _classCallCheck(this, ContactChangeRequest);

    return _possibleConstructorReturn(this, _getPrototypeOf(ContactChangeRequest).call(this, "ContactChangeRequest"));
  }

  _createClass(ContactChangeRequest, [{
    key: "Approve",
    value: function () {
      var _Approve = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(obj) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt("return", axios.post("/api/".concat(this._controller, "/Approve"), obj));

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function Approve(_x) {
        return _Approve.apply(this, arguments);
      }

      return Approve;
    }()
  }, {
    key: "Reject",
    value: function () {
      var _Reject = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2(obj) {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                return _context2.abrupt("return", axios.post("/api/".concat(this._controller, "/Reject"), obj));

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function Reject(_x2) {
        return _Reject.apply(this, arguments);
      }

      return Reject;
    }()
  }, {
    key: "SendSubmissionEmails",
    value: function () {
      var _SendSubmissionEmails = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee3(projectId, requestId) {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                return _context3.abrupt("return", axios.post("/api/".concat(this._controller, "/SendSubmissionEmails/").concat(projectId, "/").concat(requestId)));

              case 1:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function SendSubmissionEmails(_x3, _x4) {
        return _SendSubmissionEmails.apply(this, arguments);
      }

      return SendSubmissionEmails;
    }()
  }, {
    key: "UpdateManagementCompanyContacts",
    value: function () {
      var _UpdateManagementCompanyContacts = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee4(managementContactsVM) {
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                return _context4.abrupt("return", axios.post("/api/".concat(this._controller, "/UpdateManagementCompanyContacts"), managementContactsVM));

              case 1:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function UpdateManagementCompanyContacts(_x5) {
        return _UpdateManagementCompanyContacts.apply(this, arguments);
      }

      return UpdateManagementCompanyContacts;
    }()
  }, {
    key: "GetContactChangeManagementCompanyRequests",
    value: function () {
      var _GetContactChangeManagementCompanyRequests = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee5(statusId) {
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                return _context5.abrupt("return", axios.post("/api/".concat(this._controller, "/GetContactChangeManagementCompanyRequests/").concat(statusId)));

              case 1:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function GetContactChangeManagementCompanyRequests(_x6) {
        return _GetContactChangeManagementCompanyRequests.apply(this, arguments);
      }

      return GetContactChangeManagementCompanyRequests;
    }()
  }, {
    key: "GetChangeManagementCompanyRequestById",
    value: function () {
      var _GetChangeManagementCompanyRequestById = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee6(requestId) {
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                return _context6.abrupt("return", axios.post("/api/".concat(this._controller, "/GetChangeManagementCompanyRequestById/").concat(requestId)));

              case 1:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function GetChangeManagementCompanyRequestById(_x7) {
        return _GetChangeManagementCompanyRequestById.apply(this, arguments);
      }

      return GetChangeManagementCompanyRequestById;
    }()
  }, {
    key: "ApproveOrRejectManagementContactChangerequest",
    value: function () {
      var _ApproveOrRejectManagementContactChangerequest = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee7(changeRequest) {
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                return _context7.abrupt("return", axios.post("/api/".concat(this._controller, "/ApproveOrRejectManagementContactChangerequest"), changeRequest));

              case 1:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function ApproveOrRejectManagementContactChangerequest(_x8) {
        return _ApproveOrRejectManagementContactChangerequest.apply(this, arguments);
      }

      return ApproveOrRejectManagementContactChangerequest;
    }()
  }, {
    key: "UpdateContactChange",
    value: function () {
      var _UpdateContactChange = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee8(changeRequestItem) {
        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                return _context8.abrupt("return", axios.post("/api/".concat(this._controller, "/UpdateContactChange"), changeRequestItem));

              case 1:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));

      function UpdateContactChange(_x9) {
        return _UpdateContactChange.apply(this, arguments);
      }

      return UpdateContactChange;
    }()
  }, {
    key: "GetContactChangeManagementCompanyRequestsByManagementId",
    value: function () {
      var _GetContactChangeManagementCompanyRequestsByManagementId = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee9(managementCoId) {
        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                return _context9.abrupt("return", axios.post("/api/".concat(this._controller, "/GetContactChangeManagementCompanyRequestsByManagementId/").concat(managementCoId)));

              case 1:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, this);
      }));

      function GetContactChangeManagementCompanyRequestsByManagementId(_x10) {
        return _GetContactChangeManagementCompanyRequestsByManagementId.apply(this, arguments);
      }

      return GetContactChangeManagementCompanyRequestsByManagementId;
    }()
  }, {
    key: "GetContactChangeManagementCompanyRequestsByOwnerManagedId",
    value: function () {
      var _GetContactChangeManagementCompanyRequestsByOwnerManagedId = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee10(ownerManagedId) {
        return _regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                return _context10.abrupt("return", axios.post("/api/".concat(this._controller, "/GetContactChangeManagementCompanyRequestsByOwnerManagedId/").concat(ownerManagedId)));

              case 1:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, this);
      }));

      function GetContactChangeManagementCompanyRequestsByOwnerManagedId(_x11) {
        return _GetContactChangeManagementCompanyRequestsByOwnerManagedId.apply(this, arguments);
      }

      return GetContactChangeManagementCompanyRequestsByOwnerManagedId;
    }()
  }, {
    key: "UnsubmitRequest",
    value: function () {
      var _UnsubmitRequest = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee11(requestId) {
        return _regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                return _context11.abrupt("return", axios.post("/api/".concat(this._controller, "/UnsubmitRequest/").concat(requestId)));

              case 1:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11, this);
      }));

      function UnsubmitRequest(_x12) {
        return _UnsubmitRequest.apply(this, arguments);
      }

      return UnsubmitRequest;
    }()
  }, {
    key: "RemoveDuplicateContacts",
    value: function () {
      var _RemoveDuplicateContacts = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee12() {
        return _regeneratorRuntime.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                return _context12.abrupt("return", axios.post("/api/".concat(this._controller, "/RemoveDuplicateContacts")));

              case 1:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12, this);
      }));

      function RemoveDuplicateContacts() {
        return _RemoveDuplicateContacts.apply(this, arguments);
      }

      return RemoveDuplicateContacts;
    }()
  }]);

  return ContactChangeRequest;
}(RequestBaseData);

export default new ContactChangeRequest();